import { useMemo, useCallback, useState } from 'react'

import MuiButton from '@mui/material/Button'
import MuiContainer from '@mui/material/Container'

import PageTitle from '../../components/page-title'
import UserDrawer from './components/userDrawer'
import UsersList from './components/userList'

const Users = () => {
  const [showDrawer, setShowDrawer] = useState(false)

  const onAddUserClick = useCallback(() => {
    setShowDrawer(true)
  }, [])

  const action = useMemo(
    () => (
      <MuiButton variant="outlined" onClick={onAddUserClick}>
        New User
      </MuiButton>
    ),
    [onAddUserClick]
  )

  return (
    <>
      <PageTitle title="Users" action={action} />
      <MuiContainer maxWidth={false} disableGutters>
        <UsersList />
      </MuiContainer>
      <UserDrawer showDrawer={showDrawer} setShowDrawer={setShowDrawer} />
    </>
  )
}

export default Users
